module.exports = "<div class=rm-grid-toolbar-user-management-manage-access-requests></div>";